import angular from 'angular';

export default angular.module('shared').constant('stateConstants', {
    license: {
        name: 'license',
        overview: {
            name: 'license_overview'
        },
        manage: {
            name: 'license_manage'
        }
    },
    support: {
        name: 'support',
        overview: {
            name: 'support_overview'
        },
        createcase: {
            name: 'support_createcase'
        },
        viewcase: {
            name: 'support_viewcase'
        }
    },
    billing: {
        name: 'billing',
        overview: {
            name: 'billing_overview'
        }
    },
    settings: {
        name: 'settings',
        permission: {
            name: 'settings_permission'
        },
        accountAuthentication: {
            name: 'settings_accountAuthentication'
        },
        userProvisioning: {
            name: 'settings_userProvisioning'
        }
    },
    cloud: {
        name: 'cloud',
        urlVerification: {
            name: 'urlVerification'
        },
        registration: {
            name: 'registration'
        }
    }
});



// WEBPACK FOOTER //
// ./modules/shared/constants/state.constant.js